import axios from '../../index'
import qs from 'qs'
/**
 * @description 分销商我的订单
 * @author txw
 * @date 2020-09-11
 * @export
 *
 */
export function requestMyCredit (params) {
  return axios.post(`/credit/load-my-credit`, qs.stringify(params))
}
